import { useQuery } from '@tanstack/react-query'
import type { TAppUser } from '@core/backend'
import { StaleTime } from '@core/query'
import { SessionQueryKey } from '../helpers/queryKeys'
import { GUEST_USER } from '../constants/guestUser'
import { fetchSessionUser } from '../services/fetchSessionUser'

export type TCurrentUser = TAppUser & {
    isAuthenticated: boolean
    isLoading: boolean
    isRefreshing: boolean
}

export const useCurrentUser = (): TCurrentUser => {
    const { data, isLoading, isFetching } = useQuery({
        queryKey: SessionQueryKey.me(),
        queryFn: fetchSessionUser,
        staleTime: StaleTime.Long,
    })

    const user = data ?? GUEST_USER

    return { ...user, isAuthenticated: user.id !== 0, isLoading, isRefreshing: isFetching }
}
